export class QuestionResponse {
  id: string | null;
  question: string;
  questionOrig: string;
  response: string;
  responseOrig: string;

  constructor(
    id: string | null,
    question: string,
    questionOrig: string,
    response: string,
    responseOrig: string) {
    this.id = id;
    this.question = question;
    this.questionOrig = questionOrig;
    this.response = response;
    this.responseOrig = responseOrig;
  }

  isFilledIn(): boolean {
    if (!this.question || !this.question.trim()) {
      return false;
    }
    if (!this.questionOrig || !this.questionOrig.trim()) {
      return false;
    }
    if (!this.response || !this.response.trim()) {
      return false;
    }
    if (!this.responseOrig || !this.responseOrig.trim()) {
      return false;
    }
    return true;
  }
}

export interface NormalizationSql {
  id: string | null,
  name: string | null,
  sql: string | null,
  normalized: string | null,
  simplified: string | null,
  questionsResponses: QuestionResponse[]
  exampleOrder: number | null,
}
